import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class RelationTypeDisplayListComponent implements IController {
  relationTypes: any;
  isRow: any;
  onChange: Function;

  constructor() {
  }

  onRemove(relationType) {
    this.onChange({relationTypes: _.filter(this.relationTypes, (i) => {return i !== relationType})});
  }

}

angular
  .module('bringoz.admin.tasks')
  .component('relationTypeDisplayList', {
    bindings: {
      relationTypes: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./relation-type-display-list.html').default,
    controller: RelationTypeDisplayListComponent
  });
